import { BoxProps, Flex } from '@chakra-ui/react';

const ProductFieldGroup = (props: BoxProps) => (
  <Flex
    sx={{
      mx: 2.5,
      py: 2.5,
      justifyContent: 'flex-start',
      borderBottom: '2px solid',
      borderColor: 'base2Colour.400',
      textTransform: 'uppercase',
    }}
    {...props}
  />
);

export default ProductFieldGroup;
